import { render } from "./ClassAnnouncements.vue?vue&type=template&id=bf963382"
import script from "./ClassAnnouncements.vue?vue&type=script&lang=js"
export * from "./ClassAnnouncements.vue?vue&type=script&lang=js"

import "./ClassAnnouncements.vue?vue&type=style&index=0&id=bf963382&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__